import { Link } from 'react-router-dom';

export default function Resources() {
  const featuredArticle = {
    image:
      'https://public.readdy.ai/ai/img_res/e44436b1af152a9ddf949b549c07572b.jpg',
    category: 'TAX STRATEGY',
    title: '2024 Tax Planning Guide: Essential Strategies for Business Owners',
    author: 'Sarah Mitchell, CPA',
    readTime: '12 min read',
    excerpt:
      'Discover the most effective tax planning strategies for the current year, including new deductions, credits, and planning opportunities.',
    link: '/articles/business-deductions'
  };

  const articles = [
    {
      image:
        'https://readdy.ai/api/search-image?query=business%20professional%20reviewing%20financial%20documents%20and%20tax%20forms%20on%20desk%20with%20calculator%20organized%20paperwork%20clean%20simple%20background%20dark%20tones&width=240&height=240&seq=article-navy-001&orientation=squarish',
      category: 'DEDUCTIONS',
      title: 'Maximizing Business Deductions: What You Need to Know',
      date: 'March 15, 2024',
      link: '/articles/business-deductions'
    },
    {
      image:
        'https://readdy.ai/api/search-image?query=retirement%20planning%20concept%20with%20financial%20charts%20graphs%20and%20calculator%20showing%20investment%20growth%20strategy%20professional%20clean%20background%20navy%20tones&width=240&height=240&seq=article-navy-002&orientation=squarish',
      category: 'RETIREMENT',
      title: 'Retirement Account Strategies for Tax Savings',
      date: 'March 10, 2024',
      link: '/articles/retirement-strategies'
    },
    {
      image:
        'https://readdy.ai/api/search-image?query=small%20business%20owner%20working%20on%20laptop%20with%20financial%20documents%20tax%20planning%20materials%20organized%20workspace%20professional%20atmosphere%20dark%20tones&width=240&height=240&seq=article-navy-003&orientation=squarish',
      category: 'SMALL BUSINESS',
      title: 'Tax Tips for Small Business Owners in 2024',
      date: 'March 5, 2024',
      link: '/articles/small-business-tips'
    },
    {
      image:
        'https://readdy.ai/api/search-image?query=estate%20planning%20documents%20with%20legal%20papers%20financial%20statements%20and%20pen%20on%20desk%20professional%20organized%20setting%20clean%20background%20dark%20navy%20tones&width=240&height=240&seq=article-navy-004&orientation=squarish',
      category: 'ESTATE PLANNING',
      title: 'Estate Tax Planning: Protecting Your Legacy',
      date: 'February 28, 2024',
      link: '/articles/estate-planning'
    }
  ];

  const resourceTypes = [
    {
      icon: 'ri-file-pdf-line',
      title: 'Downloadable Tax Guides',
      description:
        'Comprehensive PDF guides covering various tax topics and strategies',
      count: '15+ Guides'
    },
    {
      icon: 'ri-play-circle-line',
      title: 'Video Tutorials',
      description:
        'Step-by-step video explanations of complex tax concepts',
      count: '25+ Videos'
    },
    {
      icon: 'ri-calendar-event-line',
      title: 'Webinar Schedule',
      description:
        'Join our live webinars on current tax topics and planning strategies',
      count: 'Monthly Events'
    }
  ];

  return (
    <section id="resources" className="py-24 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16">
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="w-8 h-px bg-[#00e5c7]"></div>
            <span className="text-[#00e5c7] text-xs uppercase tracking-[0.3em] font-semibold">
              Knowledge Center
            </span>
          </div>
          <h2
            className="text-4xl md:text-5xl font-bold text-[#0a1628]"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Tax Resources &amp; Insights
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-8">
          {/* Featured Article */}
          <Link 
            to={featuredArticle.link}
            onClick={() => window.scrollTo(0, 0)}
            className="relative rounded-lg overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 cursor-pointer group"
          >
            <div className="aspect-[4/3] w-full h-full">
              <img
                src={featuredArticle.image}
                alt={featuredArticle.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628]/90 via-[#0a1628]/40 to-[#0a1628]/10"></div>
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <span className="inline-block px-3 py-1 bg-[#00e5c7] text-[#0a1628] text-xs uppercase tracking-wider rounded-md font-semibold mb-4">
                {featuredArticle.category}
              </span>
              <h3
                className="text-2xl font-bold text-white mb-4 leading-tight"
                style={{ fontFamily: "'Outfit', sans-serif" }}
              >
                {featuredArticle.title}
              </h3>
              <div className="flex items-center text-white/70 text-sm">
                <span>{featuredArticle.author}</span>
                <span className="mx-3">•</span>
                <span>{featuredArticle.readTime}</span>
              </div>
            </div>
          </Link>

          {/* Article List */}
          <div className="space-y-4">
            {articles.map((article, index) => (
              <Link
                key={index}
                to={article.link}
                onClick={() => window.scrollTo(0, 0)}
                className="flex gap-4 bg-white rounded-lg p-4 border border-gray-200/80 hover:border-[#00e5c7]/30 hover:shadow-lg transition-all duration-300 cursor-pointer group"
              >
                <div className="w-24 h-24 flex-shrink-0 rounded-lg overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="flex-1 flex flex-col justify-center">
                  <span className="text-[#00e5c7] text-xs uppercase tracking-wider font-semibold mb-1">
                    {article.category}
                  </span>
                  <h4 className="text-sm font-bold text-[#0a1628] mb-1 group-hover:text-[#00e5c7] transition-colors" style={{ fontFamily: "'Outfit', sans-serif" }}>
                    {article.title}
                  </h4>
                  <span className="text-xs text-[#5a6a7e]">{article.date}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>

        {/* Resource Types */}
        <div className="grid md:grid-cols-3 gap-6 mt-12">
          {resourceTypes.map((resource, index) => (
            <div
              key={index}
              className="bg-[#0a1628] rounded-lg p-8 hover:shadow-xl transition-all duration-300 cursor-pointer group relative overflow-hidden"
            >
              <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-bl from-[#00e5c7]/10 to-transparent"></div>
              <div className="w-14 h-14 rounded-lg bg-[#00e5c7]/15 flex items-center justify-center mb-6 group-hover:bg-[#00e5c7]/25 transition-colors">
                <i className={`${resource.icon} text-3xl text-[#00e5c7]`}></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>
                {resource.title}
              </h3>
              <p className="text-sm text-white/60 mb-4">{resource.description}</p>
              <span className="text-[#00e5c7] text-sm font-semibold">{resource.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
